<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
               <h5>{{$t('FLOW')}}</h5>
               <div v-if="globals.acl.Flow.insertAction">
                    <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
                </div>
            </div>
            <div class="card-body" v-if="(globals.acl.AclGroups && globals.acl.AclGroups.insertAction)">
              <div class="row">
                <div class="col-12">
                  <div class="flex-0-auto mb-3">
                    <div class="buttons-group">
                      <label class="has-float-label mr-2">
                          <b-form-fieldset v-bind:label="$t('USERCOMPANIES')">
                              <lbselect 
                                :empty="true" 
                                :list="companyData.root" 
                                :total-count="companyData.totalCount"
                                :pagination="paginationCompany"
                                v-on:reload="getCompanyData()"
                                v-model="paginationSec.companyId" 
                                value-field="companyId" 
                                display-field="companyName">
                              </lbselect>
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <button type="button" class="btn-bis btn-tertiary mtt-2" @click="getData()"><!--icon icon="search"></icon-->{{$t('SEARCH')}}</button>
                          </b-form-fieldset>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('DESCRIPTION')}}</th>
                    <th v-if="(globals.acl.AclGroups && globals.acl.AclGroups.insertAction)">{{$t('COMPANYNAME')}}</th>
                    <template v-if="(globals.acl.Flow && globals.acl.Flow.insertAction)">
                        <th>{{$t('OVERWRITE')}}</th>
                        <th>{{$t('NUMBEROFSTEPS')}}</th>
                        <th>{{$t('NUMBEROFSTEPBUTONS')}}</th>
                        <th>{{$t('NUMBEROFQUESTIONS')}}</th>
                    </template>
                    <th v-if="globals.acl.Flow.insertAction">{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.root" :key="item.flowId" aria-rowindex="1" class=" table-ellipsis" :class="(item.numberOfSteps > 0) ? '' : ' invalid'">
                        <td>{{item.flowId}}</td>
                        <td>{{item.description}}</td>
                        <th v-if="(globals.acl.AclGroups && globals.acl.AclGroups.insertAction)">{{item.companyName}}</th>
                        <template v-if="(globals.acl.Flow && globals.acl.Flow.insertAction)">
                            <td>{{item.overwrite}}</td>
                            <td>{{item.numberOfSteps}}</td>
                            <td>{{item.numberOfStepButons}}</td>
                            <td>{{item.numberOfQuestions}}</td>
                            <td v-if="globals.acl.Flow.insertAction" class="table-buttons">
                                <b-button type="reset" class="btn-table table-btn-secondary" @click="showDetails(item)">{{$t('STEP')}}</b-button>
                                <b-button type="reset" class="btn-table table-btn-secondary ml-2" @click="copyFlow(item)">{{$t('COPY')}}</b-button>
                                <b-button type="reset" class="btn-table table-btn-secondary ml-2" @click="printToPdf(item.flowId)">{{$t('PDF')}}</b-button>
                                <b-button type="reset" class="btn-table table-btn-tertiary ml-2"  @click="showModal(item)">{{$t('EDIT')}}</b-button>
                                <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.flowId)">{{$t('DELETE')}}</b-button>
                            </td>
                        </template>
                    </tr>
                </tbody>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <b-modal ref="formmodal" centered ok-title="submit" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('FLOWFORM')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="hideModal()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
            <flowform v-bind:formData="formData" v-bind:formError="formError"></flowform>

            <div class="text-center mt-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
        </div>
    </b-modal>
    <copyform v-model="formCopyData" v-on:close="formCopyData = null; getData()"></copyform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/flow/FlowTrafficSafetyManagment.js';
import FlowForm from './Form.vue';
import CopyForm from './CopyForm.vue';
import CompanyApi from '@/api/admin/UserCompanies'

export default {
    name: 'FlowSec',
    components:
    {
        flowform: FlowForm,
        copyform: CopyForm
    },
    data()
    {
        const me = this;

        me.formDataField = {
            description: '',
            overwrite: 0,
        };

        return {
            loading: true,
            data: {},
            companyData: {},
            formError: {},
            paginationSec: {
                companyId: null,
            },
            formCopyData: null,
            formData: {...me.formDataField},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationCompany: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getCompanyData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await CompanyApi.selectRow(me.getParamsCompany);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.companyData = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async printToPdf(flowId)
      {
          const me = this;
          try
          {
              await Api.printToPdf({ flowId: flowId });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showDetails(item)
      {
          const me = this;
          me.$router.push(
              {
                  path: `/flowsec/step/${item.flowId}`,
                  query: { flowName: item.description },
              },
          );
      },
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = { ...item };
          }
          this.$refs.formmodal.show();
      },
      async copyFlow(item)
      {
          const me = this;
          if (me.globals.acl.UserSubCompanies && me.globals.acl.UserSubCompanies.companyAction == false)
          {
            if (item == null)
            {
                item = {};
            }
            me.formCopyData = { ...item };
          }
          else
          {
              me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHUREYOUWANTTOCOPYFLOW'),
                  async btnAction()
                  {
                      const data = await Api.copyFlow({flowId: item.flowId});
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
          }          
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              me.loading = true;
              if (typeof item.flowId !== 'undefined')
              {
                  item.id = item.flowId;
                  delete (item.flowId);
              }

              const data = await Api.save(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }

              me.$notify.notice(data);
              me.getData();
              me.hideModal();
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      hideModal()
      {
          const me = this;

          me.formError = {};
          me.formData = {...me.formDataField},
          this.$refs.formmodal.hide();
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination, ...me.paginationSec };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsCompany()
      {
          const me = this;
          const data = { ...me.paginationCompany };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
